import React from "react";
import Seo from "@/components/Seo";

const HERO = "https://static.prod-images.emergentagent.com/jobs/7e6ca0f8-68b2-4411-b9b5-f4664e141e03/images/d9180094995df78a87906bb3ecb7843c90b7af767d20475bf2fa35b5dfa9628f.png";

export default function AboutPage() {
  return (
    <>
      <Seo title="À propos · Notre mission" description="L'histoire et la mission de Recette-Diabete : rendre la cuisine française accessible aux diabétiques." path="/a-propos" />
      <section className="container-x pt-20 pb-12">
        <p className="overline mb-3">Notre histoire</p>
        <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight max-w-4xl">
          Né du <em className="text-[hsl(var(--brand-primary))] font-medium">diagnostic</em>, porté par la <em className="text-[hsl(var(--brand-primary))] font-medium">passion</em>.
        </h1>
      </section>

      <section className="container-x py-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-5">
          <img src={HERO} alt="" className="w-full aspect-[4/5] object-cover rounded-sm" />
        </div>
        <div className="md:col-span-7 editorial-prose">
          <p className="text-xl text-[hsl(var(--text-primary))] !mb-8 font-serif italic">
            "Je n'ai pas accepté de renoncer aux plats que j'aime. J'ai cherché, j'ai testé, j'ai adapté.
            Recette-Diabete est né de ce refus."
          </p>
          <h2>Notre mission</h2>
          <p>
            Le diabète touche des millions de personnes. Le diagnostic s'accompagne souvent d'un sentiment
            de privation, de listes d'interdits, et d'un découragement face à la cuisine — pourtant pilier de notre quotidien.
          </p>
          <p>
            Recette-Diabete propose une approche inverse : montrer que les recettes que vous aimez, qu'elles viennent
            du terroir français ou d'ailleurs dans le monde, sont <strong>parfaitement compatibles</strong> avec une vie de diabétique.
            Ratatouille, dahl indien, tajine, clafoutis, sushis adaptés… tout reste possible avec quelques ajustements ciblés.
          </p>

          <h2>Nos engagements</h2>
          <ul>
            <li>Chaque recette publiée affiche son <strong>index glycémique estimé</strong>.</li>
            <li>Aucune recette à IG élevé n'est publiée.</li>
            <li>Les conseils diététiques sont basés sur les recommandations officielles (HAS, AFD, ADA).</li>
            <li>Des cuisines du monde entier, adaptées avec le même soin.</li>
            <li>Nous restons gratuits, indépendants, sans publicité intrusive.</li>
          </ul>

          <h2>L'équipe</h2>
          <p>
            Recette-Diabete est édité par un petit comité de passionnés : un fondateur diabétique de type 2,
            une diététicienne, et un chef cuisinier. Chaque recette est relue et validée avant publication.
          </p>

          <blockquote>
            La cuisine n'est pas l'ennemie du diabétique. Elle est, au contraire, l'outil le plus puissant
            pour reprendre le contrôle, le plaisir et la santé.
          </blockquote>
        </div>
      </section>
    </>
  );
}
